import {UserMenuRootDefaultBox} from "./user-menu-root.default.box";
import {styledByTheme} from "../../../../../themes/architecture/styled-by-theme";
import {UserMenuRootCasino777Box} from "./user-menu-root.casino777.box";

export const UserMenuRootBox = styledByTheme(UserMenuRootDefaultBox).forCasino777(UserMenuRootCasino777Box).apply();
